import React, { useState, useEffect, useContext, useRef } from "react";
import { Container } from "react-bootstrap";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ViewLogsContainerMobile from "./ViewLogs/ViewLogsContainerMobile";
import UpdateScheduleImg from "../../../assets/update-schedule.png";
import MyVacations from "../../../assets/My Vacations.png";
import ViewCalendar from "../../../assets/View Calendar.png";
import RescheduleIcon from "../../../assets/reschedule_icon.svg";
import { MyScheduleFeesContextProvider } from "./MyScheduleFeesContext";
import { getApiUrl } from "./ViewLogs/ViewLogsHelper";
import UpdateScheduleDetails from "./UpdateSchedule/index";
import ViewCalendarDetails from "./ViewCalendar/index";
import VacationsDays from "./MyVacations/vacations";

import "../../styles/MySchedule.scss";
import StaffHeader from "../../Staff/CommonComponents/StaffHeader";
import CustomSelect from "../../UI Component/CustomSelect/CustomSelect";
import SelectDoctorImg from "../../../assets/HealthProgession.svg";
import DownloadReport from "../../DownloadReport/DownloadReport";
import ClinicWrapper from "../../ClinicComponents/ClinicWrapper";
import DoctorContext from "../../ClinicComponents/ClinicWrapper/DoctorContext";
import BulkReschedule from "./BulkReschedule";
import {
  BULK_RESCHEDULE,
  DELAY_MARKING_RADIO_BTN,
  MY_VACATIONS,
  MY_VACATIONS_RADIO_BTN,
  UPDATE_SCHEDULE,
  VIEW_CALENDAR,
} from "./Constants";
import MyScheduleAndFeesTabComponent from "./TabComponent";
import DelayMarkedPopup from "./UpdateSchedule/DelayMarkedPopup";
import { APPLICABLE_ROLE } from "../../DashboardAppointmentsView/Constant";
import Loader from "../../UI Component/Loader/Loader";
import { DELAY_LOGS } from "./ViewLogs/ViewLogsApiHandler/APIConstants";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { USER_ROLE, USER_TYPE } from "../../../Util/constants";
import InformationBox from "../../common/InformationBox";
import { c2cPostApiHandler } from "../../../Util/c2cApiHandler";

export default function MyScheduleFees() {
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  function a11yProps(index) {
    return {
      id: `scrollable-force-tab-${index}`,
      "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
  }

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      width: "100%",
      backgroundColor: theme.palette.background.paper,
    },
  }));

  const useStyle = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: "33.33%",
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
  }));

  const classes = useStyles();
  const [showLoader, setShowLoader] = React.useState(0);
  const classesAccordion = useStyle();
  const [expanded, setExpanded] = React.useState(false);
  const [showLogsMobile, setShowLogsMobile] = React.useState(false);
  const [callProcedureApi, setCallProcedureApi] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState({});
  const [logType, setLogType] = useState(UPDATE_SCHEDULE);
  const [tableData, setTableData] = useState([]);
  const [tableDataMobile, setTableDataMobile] = useState([]);
  const [roleNameMenu, setRoleNameMenu] = useState({
    update_schedule: [],
    view_calendar: [],
    my_vacations: [],
    bulk_reschedule: [],
  });
  const [logFilterData, setLogFilterData] = useState({});
  const defaultLogFilter = {
    start_date: "",
    end_date: "",
    page_number: "1",
    record_per_page: "10",
    doctor_name_filter: "all",
    role_filter: "all",
    consultation_filter: "All",
    action_filter: "all",
  };
  const [isViewLogOpened, setIsViewLogOpened] = useState(false);
  const [totalRecords, setTotalRecords] = useState();
  const [dropdownOptionsList, setDropdownOptionsList] = useState({
    update_schedule: [],
    view_calendar: [],
  });
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION
  );
  const [selectedRadioBtn, setSelectedRadioBtn] = useState(
    MY_VACATIONS_RADIO_BTN
  );
  const logTypeRef = useRef();
  const handleChangeAccordion = (panel, logType) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    setLogType(logType);
    // getLogsData(logType);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-force-tabpanel-${index}`}
        aria-labelledby={`scrollable-force-tab-${index}`}
        {...other}
      >
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

  const [selectedDoctorList, setSelectedDoctorList] = useState([]);
  const [doctorRole, setDoctorRole] = useState();

  const doctor_context = useContext(DoctorContext);
  const doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );
  const [isVirtualClinic, setIsVirtualClinic] = useState(true);
  const [openDelayMarkedPopup, setOpenDelayMarkedPopup] = useState(false);
  const [scheduleId, setScheduleId] = useState("");
  const [isResourceArray, setIsResourceArray] = useState("False");
  /***
    @description: this useEffect for staff who is not associated to any clinic
  */

  useEffect(() => {
    if (
      userType == "staff" &&
      staffClinicAssociation == "false" &&
      doctor_context?.selectedDoctor
    ) {
      setSelectedDoctorList(doctor_context?.selectedDoctor);
    }
  }, [doctor_context?.selectedDoctor]);

  /***
    @description: useEffect for staff virtual clinic who is  also associated with clinic
  */

  const updateSelectedDoctorList = () => {
    let arr = [];
    doctor_context.selectedDoctor.forEach((data) => {
      if (data.selected === true) {
        arr.push(data);
      }
    });
    setSelectedDoctorList(arr);
  };

  useEffect(() => {
    if (
      userType === "staff" &&
      staffClinicAssociation === "true" &&
      doctor_context?.selectedDoctor.length > 0
    ) {
      updateSelectedDoctorList();
    }
  }, [doctor_context?.selectedDoctor, staffClinicAssociation, userType]);

  useEffect(() => {
    if (doctor_context?.clinic_id) {
      setDoctorRole(localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE));
      setIsVirtualClinic(false);
    } else {
      setDoctorRole("");
      setIsVirtualClinic(true);
    }
    setOpenDelayMarkedPopup(false);
  }, [doctor_context?.clinic_id]);

  useEffect(() => {
    if (
      doctorClinicAssociation === "true" &&
      doctor_context?.selectedDoctor.length > 0 &&
      doctor_context?.clinic_id
    ) {
      updateSelectedDoctorList();
      setSelectedDoctor({});
    }
  }, [
    doctor_context?.selectedDoctor,
    doctor_context?.clinic_id,
    doctorClinicAssociation,
  ]);

  useEffect(() => {
    if (
      localStorage.getItem("staff_selected_dr") !== undefined &&
      doctor_context?.selectedDoctor
    ) {
      let selectedOption = JSON.parse(
        localStorage.getItem("staff_selected_dr")
      );
      let arr = [];
      doctor_context.selectedDoctor.map((data, inx) => {
        if (data.selected === true) {
          arr.push(data);
        }
      });
      let selectedOptionDoctor = arr.find(
        (ele) => ele?.doctor_id === selectedOption?.doctor_id
      );
      if (selectedOption?.doctor_id && selectedOptionDoctor?.doctor_id) {
        setSelectedDoctor(selectedOptionDoctor);
      }
    }
    // else {
    //   setSelectedDoctor({});
    // }
  }, [
    localStorage.getItem("staff_selected_dr"),
    doctor_context?.selectedDoctor,
  ]);

  useEffect(() => {
    let isResource = clinicId ? selectedDoctor?.is_resource : "False";
    setIsResourceArray(isResource);
    localStorage.setItem("isResourceArray", isResource);
  }, [selectedDoctor]);

  // useEffect to set the previous selected doctor
  useEffect(() => {
    let prevSelectedDoctor = localStorage.getItem("staff_selected_dr");
    if (prevSelectedDoctor && doctor_context?.doctorList?.length > 0) {
      prevSelectedDoctor = JSON.parse(prevSelectedDoctor);
      let filterPrevDoctor = doctor_context.doctorList.filter((data) => {
        return prevSelectedDoctor.doctor_id == data.doctor_id;
      });
      if (filterPrevDoctor.length > 0) {
        setSelectedDoctor(filterPrevDoctor[0]);
      } else {
        localStorage.removeItem("staff_selected_dr");
        setSelectedDoctor({});
      }
    }
  }, [doctor_context?.doctorList, doctor_context?.clinic_id]);

  const handleOnChange = (option) => {
    setSelectedDoctor(option);
    setCallProcedureApi(true);
    setTimeout(() => {
      setCallProcedureApi(false);
    }, 100);
    localStorage.setItem("staff_selected_dr", JSON.stringify(option));
  };

  useEffect(() => {
    if (isViewLogOpened) {
      if (logTypeRef.current !== logType) {
        logTypeRef.current = logType;
        if (
          logType === MY_VACATIONS &&
          selectedRadioBtn === DELAY_MARKING_RADIO_BTN
        ) {
          getDelayLogsData(logType, defaultLogFilter);
        } else {
          getLogsData(logType, defaultLogFilter);
        }
        setLogFilterData(defaultLogFilter);
      } else {
        if (
          logType === MY_VACATIONS &&
          selectedRadioBtn === DELAY_MARKING_RADIO_BTN
        ) {
          getDelayLogsData(logType, logFilterData);
        } else {
          getLogsData(logType, logFilterData);
        }
      }
    }
  }, [logType, isViewLogOpened]);

  const getLogsData = (logType, data) => {
    let payload = {
      doctor_id:
        userType === APPLICABLE_ROLE.STAFF ||
        doctorRole === USER_ROLE.DOCTOR_ADMIN ||
        doctorRole === USER_ROLE.RESOURCE_ADMIN
          ? selectedDoctor.id
          : userId,
      ...data,
      ...(clinicId && { clinic_id: clinicId }),
    };
    setShowLoader(true);
    let url = getApiUrl(logType);
    c2cPostApiHandler(url, payload).then((response) => {
      setShowLoader(false);
      if (response[0]?.data?.statusCode === 200) {
        if (response[0]?.data?.data?.length > 0) {
          setTableData({ [logType]: response[0]?.data?.data });
          setTableDataMobile({
            ...tableDataMobile,
            [logType]: response[0]?.data?.data,
          });
        } else {
          setTableData({ [logType]: [] });
          setTableDataMobile({
            ...tableDataMobile,
            [logType]: [],
          });
        }
        if (response[0]?.data?.procedure_list?.length > 0) {
          let arr = response[0].data.procedure_list.map(
            (procedureName, index) => ({
              name: procedureName,
              id: index,
              label: procedureName,
            })
          );
          const isDuplicate = (list, newItem) =>
            list.some((item) => item.name === newItem.name);
          if (
            logType === VIEW_CALENDAR &&
            !isDuplicate(dropdownOptionsList.view_calendar, arr[0])
          ) {
            setDropdownOptionsList({
              ...dropdownOptionsList,
              view_calendar: [...dropdownOptionsList.view_calendar, ...arr],
            });
          }

          if (
            logType === UPDATE_SCHEDULE &&
            !isDuplicate(dropdownOptionsList.update_schedule, arr[0])
          ) {
            setDropdownOptionsList({
              ...dropdownOptionsList,
              update_schedule: [...dropdownOptionsList.update_schedule, ...arr],
            });
          }
        }

        if (response[0]?.data?.doctor_list?.length > 0) {
          let arr = [];
          response[0].data.doctor_list.forEach((d, index) => {
            let obj = {};
            obj["name"] = d;
            obj["value"] = d;
            obj["id"] = index;
            arr.push(obj);
          });
          if (logType === VIEW_CALENDAR) {
            setRoleNameMenu({ ...roleNameMenu, view_calendar: arr });
          }
          if (logType === UPDATE_SCHEDULE) {
            setRoleNameMenu({ ...roleNameMenu, update_schedule: arr });
          }
          if (logType === MY_VACATIONS) {
            setRoleNameMenu({ ...roleNameMenu, my_vacations: arr });
          }
          if (logType === BULK_RESCHEDULE) {
            setRoleNameMenu({ ...roleNameMenu, bulk_reschedule: arr });
          }
          setTotalRecords(response[0]?.data?.total_records);
        }
      } else {
        setTableData({ [logType]: [] });
        setTableDataMobile({
          ...tableDataMobile,
          [logType]: [],
        });
        setTotalRecords(0);
        setRoleNameMenu({
          update_schedule: [],
          view_calendar: [],
          my_vacations: [],
          bulk_reschedule: [],
        });
      }
    });
  };

  const handleViewLogOnFilter = (filtered_payload) => {
    let payload = { ...logFilterData, ...filtered_payload };
    setLogFilterData(payload);
    if (
      logType === MY_VACATIONS &&
      selectedRadioBtn === DELAY_MARKING_RADIO_BTN
    ) {
      getDelayLogsData(logType, payload);
    } else {
      getLogsData(logType, payload);
    }
  };

  const handleViewLogOpened = () => {
    setIsViewLogOpened(!isViewLogOpened);
  };

  const handleShowDelayMarkedPopup = (id) => {
    setScheduleId(id);
    setOpenDelayMarkedPopup(true);
  };

  const handleClosePopup = () => {
    setOpenDelayMarkedPopup(false);
  };

  const handleRadioBtn = (e) => {
    if (selectedRadioBtn !== e.target.value) {
      setSelectedRadioBtn(e.target.value);
      setLogFilterData(defaultLogFilter);
      if (e.target.value === MY_VACATIONS_RADIO_BTN) {
        setLogFilterData(defaultLogFilter);
        getLogsData(logType, defaultLogFilter);
      } else if (e.target.value === DELAY_MARKING_RADIO_BTN) {
        setLogFilterData(defaultLogFilter);
        getDelayLogsData(logType, defaultLogFilter);
      }
    }
  };

  const getDelayLogsData = (logType, data) => {
    let payload = {
      doctor_id:
        userType === APPLICABLE_ROLE.STAFF ||
        doctorRole === USER_ROLE.DOCTOR_ADMIN ||
        doctorRole === USER_ROLE.RESOURCE_ADMIN
          ? selectedDoctor.id
          : userId,
      ...data,
      ...(clinicId && { clinic_id: clinicId }),
    };
    setShowLoader(true);
    let url = DELAY_LOGS;
    c2cPostApiHandler(url, payload).then((response) => {
      setShowLoader(false);
      if (response[0]?.data?.statusCode === 200) {
        if (response[0]?.data?.data?.length > 0) {
          response[0].data.data.map((data) => {
            data["created_at"] = data?.updated_at;
          });
          setTableData({ [logType]: response[0]?.data?.data });
          setTableDataMobile({
            ...tableDataMobile,
            [logType]: response[0]?.data?.data,
          });
        } else {
          setTableData({ [logType]: [] });
          setTableDataMobile({
            ...tableDataMobile,
            [logType]: [],
          });
        }
        if (response[0]?.data?.doctor_list?.length > 0) {
          let arr = [];
          response[0].data.doctor_list.forEach((d, index) => {
            let obj = {};
            obj["name"] = d;
            obj["value"] = d;
            obj["id"] = index;
            arr.push(obj);
          });
          if (logType === MY_VACATIONS) {
            setRoleNameMenu({ ...roleNameMenu, my_vacations: arr });
          }
          setTotalRecords(response[0]?.data?.total_records);
        }
      } else {
        setTableData({ [logType]: [] });
        setTableDataMobile({
          ...tableDataMobile,
          [logType]: [],
        });
        setTotalRecords(0);
        setRoleNameMenu({
          update_schedule: [],
          view_calendar: [],
          my_vacations: [],
          bulk_reschedule: [],
        });
      }
    });
  };

  return (
    <MyScheduleFeesContextProvider>
      {showLoader ? <Loader /> : null}
      <div className={classes.root}>
        <div className={classes.main}>
          <div className="row wrapper-schedule m-0">
            {userType === "doctor" && doctorClinicAssociation == "false" ? (
              <div className="my-schedule-and-fees d-flex justify-content-between">
                <strong>MY SCHEDULE &amp; FEES </strong>
              </div>
            ) : (
              <>
                <div className="w-100">
                  {/* <PageHeading text={"MY SCHEDULE & FEES"} /> */}
                  <div
                    className=" b-bottom"
                    style={{
                      boxShadow: "0px 1px 10px #00000029",
                    }}
                  >
                    {/* <StaffHeader
                      isPageHeading={true}
                      headerText="MY SCHEDULE & FEES"
                    /> */}
                    <div
                      style={{
                        // borderBottom: "1px solid #d6dae5",
                        display: "flex",
                      }}
                    >
                      {doctorClinicAssociation == "true" ||
                      staffClinicAssociation == "true" ? (
                        <ClinicWrapper
                          isPageHeading={true}
                          headerText={"MY SCHEDULE & FEES"}
                        />
                      ) : (
                        <StaffHeader
                          isPageHeading={true}
                          headerText="MY SCHEDULE & FEES"
                        />
                      )}
                    </div>
                  </div>

                  {(doctorClinicAssociation == "true" &&
                    doctorRole == USER_ROLE.DOCTOR_ADMIN) ||
                  doctorRole === USER_ROLE.RESOURCE_ADMIN ||
                  userType == "staff" ? (
                    <div className="settings-select">
                      <div className="account-dropdown-and-info-box-wrapper">
                        <div
                          className="col-sm-12 col-lg-5 col-12  d-flex"
                          style={{ zIndex: 7 }}
                        >
                          <label className="d-flex align-items-center mb-0 mr-3">
                            Account
                          </label>
                          <CustomSelect
                            className="select_dropdownOptions"
                            showSearch={true}
                            placeholder={"Select Doctor"}
                            options={selectedDoctorList}
                            //   value={myScheduleFeesContext.selectedConsultationType}
                            value={selectedDoctor}
                            handleChange={handleOnChange}
                            isSearchable={false}
                            seacrhbarPlaceholder={"Search for Doctor"}
                          />
                        </div>
                        {(doctorRole === USER_ROLE.RESOURCE_ADMIN ||
                          doctorRole === USER_ROLE.DOCTOR_ADMIN ||
                          userType === USER_TYPE.STAFF) &&
                          selectedDoctor.common_procedure && (
                            <div className="info-box-wrapper">
                              <InformationBox title="Procedure duration and time slots will remain the same for all added procedures" />
                            </div>
                          )}
                      </div>
                    </div>
                  ) : null}
                </div>
              </>
            )}
            {/* Set availability used in desktop view*/}
            <div className="col-lg-12 col-sm-12 d-lg-block p-4 myschedule-section">
              {
                // userType === "doctor" ||
                // (userType === "staff" && selectedDoctor?.id)
                doctorClinicAssociation == "false" ||
                (doctorClinicAssociation == "true" &&
                  selectedDoctor?.id &&
                  (doctorRole === USER_ROLE.DOCTOR_ADMIN ||
                    doctorRole === USER_ROLE.RESOURCE_ADMIN)) ||
                (doctorClinicAssociation == "true" &&
                  (doctorRole === USER_ROLE.DOCTOR_CONSULTANT ||
                    isVirtualClinic ||
                    doctorRole === USER_ROLE.RESOURCE_CONSULTANT)) ||
                (userType === "staff" && selectedDoctor?.id) ||
                (isVirtualClinic &&
                  staffClinicAssociation == "true" &&
                  selectedDoctor?.id) ? (
                  <>
                    <Container>
                      <div
                        className="bg-white web-section"
                        style={{
                          minHeight: "80vh",
                          borderRadius: "10px",
                          border: "1px solid #E2E2E2",
                          borderTopRightRadius: "10px !important",
                        }}
                      >
                        <MyScheduleAndFeesTabComponent
                          isResourceArray={isResourceArray}
                          logType={logType}
                          setLogType={setLogType}
                          clinic_id={doctor_context?.clinic_id}
                          staffDoctor={selectedDoctor}
                          callProcedureApi={callProcedureApi}
                          roleNameMenu={roleNameMenu}
                          tableData={tableData}
                          handleViewLogOnFilter={handleViewLogOnFilter}
                          logFilterData={logFilterData}
                          handleViewLogOpened={handleViewLogOpened}
                          // setIsViewLogOpened={setIsViewLogOpened}
                          handleViewSlots={() => setLogType(VIEW_CALENDAR)}
                          totalRecords={totalRecords}
                          selectedRadioBtn={selectedRadioBtn}
                          handleRadioBtn={handleRadioBtn}
                          dropdownOptionsList={dropdownOptionsList}
                        />
                      </div>
                    </Container>

                    {/* mobile view 3 tabs */}
                    {showLogsMobile ? (
                      <div className="mobile-section">
                        <ViewLogsContainerMobile
                          backClick={() => {
                            setShowLogsMobile(false);
                            handleViewLogOpened();
                          }}
                          logType={logType}
                          procedureDropDown={selectedDoctor}
                          roleNameMenu={roleNameMenu}
                          tableData={tableData} //{tableDataMobile}
                          logFilterData={logFilterData}
                          totalRecords={totalRecords}
                          handleViewLogOnFilter={handleViewLogOnFilter}
                          selectedRadioBtn={selectedRadioBtn}
                          isResourceArray={isResourceArray}
                          handleRadioBtn={handleRadioBtn}
                        />
                      </div>
                    ) : window.innerWidth < 767 && openDelayMarkedPopup ? (
                      <DelayMarkedPopup
                        openDelayMarkedPopup={openDelayMarkedPopup}
                        scheduleId={scheduleId}
                        handleClosePopup={handleClosePopup}
                      />
                    ) : (
                      <div className="mobile-section + {classesAccordion.root}">
                        <Accordion
                          expanded={expanded === "panel1"}
                          onChange={handleChangeAccordion(
                            "panel1",
                            UPDATE_SCHEDULE
                          )}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                          >
                            <img
                              src={UpdateScheduleImg}
                              alt="update schedule"
                            />
                            <div className="typography-section pt-2">
                              <Container
                                className={classesAccordion.secondaryHeading}
                              >
                                <b>Update Schedule</b>
                              </Container>
                              <p>Set duration and fee for consultation</p>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Container>
                              {expanded === "panel1" && (
                                <UpdateScheduleDetails
                                  handleViewSlots={handleChangeAccordion(
                                    "panel2",
                                    VIEW_CALENDAR
                                  )}
                                  setShowLogsMobile={() => {
                                    setShowLogsMobile(true);
                                    handleViewLogOpened();
                                  }}
                                  setLogType={setLogType}
                                  staffDoctor={selectedDoctor}
                                  handleViewLogOpened={handleViewLogOpened}
                                  handleShowDelayMarkedPopup={
                                    handleShowDelayMarkedPopup
                                  }
                                />
                              )}
                            </Container>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion
                          expanded={expanded === "panel2"}
                          onChange={handleChangeAccordion(
                            "panel2",
                            VIEW_CALENDAR
                          )}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <img src={MyVacations} alt="vacations" />
                            <div className="typography-section pt-2">
                              <Container
                                className={classesAccordion.secondaryHeading}
                              >
                                <b> View Calendar</b>
                              </Container>
                              <p>Manage time slots for consultation</p>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Container>
                              {expanded === "panel2" && (
                                <ViewCalendarDetails
                                  staffDoctor={selectedDoctor}
                                  setShowLogsMobile={() => {
                                    setShowLogsMobile(true);
                                    handleViewLogOpened();
                                  }}
                                  setLogType={setLogType}
                                  // handleViewLogOpened={handleViewLogOpened}
                                />
                              )}
                            </Container>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion
                          expanded={expanded === "panel3"}
                          onChange={handleChangeAccordion(
                            "panel3",
                            MY_VACATIONS
                          )}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel3bh-content"
                            id="panel3bh-header"
                          >
                            <img src={ViewCalendar} alt="calendar" />
                            <div className="typography-section pt-2">
                              <Container
                                className={classesAccordion.secondaryHeading}
                              >
                                <b>My Vacations</b>
                              </Container>
                              <p>Plan your leaves / vacation</p>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Container>
                              {expanded === "panel3" && (
                                <VacationsDays
                                  staffDoctor={selectedDoctor}
                                  setShowLogsMobile={() => {
                                    setShowLogsMobile(true);
                                    handleViewLogOpened();
                                  }}
                                  setLogType={setLogType}
                                  handleViewLogOpened={handleViewLogOpened}
                                />
                              )}
                            </Container>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion
                          expanded={expanded === "panel4"}
                          onChange={handleChangeAccordion(
                            "panel4",
                            BULK_RESCHEDULE
                          )}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel4bh-content"
                            id="panel4bh-header"
                          >
                            <img src={RescheduleIcon} alt="calendar" />
                            <div className="typography-section pt-2">
                              <Container
                                className={classesAccordion.secondaryHeading}
                              >
                                <b>Bulk Reschedule</b>
                              </Container>
                              <p>Bulk Reschedule Appointments</p>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Container>
                              {expanded === "panel4" && (
                                <BulkReschedule
                                  staffDoctor={selectedDoctor}
                                  clinic_id={doctor_context?.clinic_id}
                                  setShowLogsMobile={() => {
                                    setShowLogsMobile(true);
                                    handleViewLogOpened();
                                  }}
                                  setLogType={setLogType}
                                  handleViewLogOpened={handleViewLogOpened}
                                />
                              )}
                            </Container>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    )}
                  </>
                ) : (
                  <div>
                    <Container>
                      <div className="no-data-container bg-white">
                        <div>
                          <div className="no-data-icon">
                            <img src={SelectDoctorImg} alt="" />
                          </div>
                          <p className="no-data-heading">Select A Doctor</p>
                          <p className="no-data-text">
                            Please select a doctor to view their records
                          </p>
                        </div>
                      </div>
                    </Container>
                  </div>
                )
              }
            </div>
          </div>
        </div>
      </div>
      <DownloadReport />
    </MyScheduleFeesContextProvider>
  );
}
